import { CleaningMission } from '@silbo/core';

export type Viewer = { userId?: string; canCleanBeds: boolean };

/** Commencer : une mission à faire, pour qui porte « nettoyer ». */
export const canStart = (mission: CleaningMission, viewer: Viewer): boolean =>
  viewer.canCleanBeds && mission.status === 'todo';

/** Interrompre ou terminer : la mission en cours, par l'agent qui l'a commencée. */
export const canInterruptOrFinish = (mission: CleaningMission, viewer: Viewer): boolean =>
  mission.status === 'in-progress' && !!viewer.userId && mission.cleaner?.id === viewer.userId;

/** Se charger : une mission à faire dont personne ne s'est chargé, pour qui porte « nettoyer ». */
export const canReserve = (mission: CleaningMission, viewer: Viewer): boolean =>
  viewer.canCleanBeds && mission.status === 'todo' && !mission.assignee;

/** Se retirer : la mission à faire dont on s'est chargé. */
export const canCancelReservation = (mission: CleaningMission, viewer: Viewer): boolean =>
  mission.status === 'todo' && !!viewer.userId && mission.assignee?.id === viewer.userId;
